// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2352":"b36b9b1e","9888":"d1ae8e9a"}[chunkId] + ".chunk.css";
};